export default __webpack_public_path__ + "static/media/AL.688d1879.svg";